interface IRowProps {
  style?: any
  content?: string | number | JSX.Element;
}

export default function CellsRow({style, content}: IRowProps) {
  return (
    <td style={style ? style : {}}>
      {content}
    </td>
  )
}